import React, { memo } from 'react';
import { motion } from 'framer-motion';
import ClusterDetailsPopup from './ClusterDetailsPopup';

function MarkersByTypeTemplate({
    markerClassName,
    idOfMarkerOfCurrentType,
    array,
    hovered,
    isMobile,
    onTouchStart,
    toggleZoom,
    $getDimensions,
    $geoService,
    $dimensionKey,
    openChangerModal,
    config,
  }) {
  return (
    <motion.div
      transition={{
        type: 'spring', stiffness: 100, damping: 7, precision: 0.001,
      }}
      whileHover={{ scale: 1.08, zIndex: 99999 }}
      style={{ zIndex: 999, position: 'relative' }}
    >
      <ClusterDetailsPopup
        data={array}
        config={config}
        mobileHover={hovered}
        isMobile={isMobile}
        onTouchStart={onTouchStart}
        openChangerModal={openChangerModal}

        toggleZoom={toggleZoom}
        id={idOfMarkerOfCurrentType}
        $getDimensions={$getDimensions}
        $geoService={$geoService}
        $dimensionKey={$dimensionKey}
      >
        <div className="simple-marker-container">
          <div className={`simple-marker ${markerClassName || ''}`} />
        </div>
      </ClusterDetailsPopup>
    </motion.div>
  );
}

export default memo(MarkersByTypeTemplate);
